module.exports = __webpack_public_path__ + "img/xsolla.ccb6e207.png";